import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';
import { Loaderpage } from './Loader';

const Protected = ({ children }) => {
  const { user, authReady } = UserAuth();
  const location = useLocation();

  // Fix: wait for Firebase session restore on refresh before routing decisions
  if (!authReady) {
    return <Loaderpage />;
  }

  if (!user?.uid) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default Protected;
